/**
 * Questions Counter View
 * This is the main view of the Questions and Answers Counter
 */
define('QuestionsCounter.View', [
    'SCView',
    'questions_counter.tpl',
    'Question.Model',
    'jQuery',
    'Utils'
], function (
    SCViewComponent,
    questions_counter_tpl,
    QuestionModel,
    jQuery,
    Utils
) {
    'use strict';
    var SCView = SCViewComponent.SCView;

    function QuestionsCounterView (options) {

      SCView.call(this, options);
      this.template = questions_counter_tpl;
      var self = this;

      //Get Q&A Tab Name from SC Configuration
      this.counterText = SC.CONFIGURATION.questionsAndAnswers.counterText;
      this.tabName = SC.CONFIGURATION.questionsAndAnswers.tabName;

      this.application = options.application;
      this.model = new QuestionModel()
      this.item = options.item;
      
      this.questionsCount = '0';

      this.model.fetch({data:{counter:true, itemid:JSON.stringify(this.item.item.internalid)}})
      .done (function(totalOfResults){

        //Get Total Q&A Count
        self.questionsCount = totalOfResults.length;

        self.render();
      });
    }

    QuestionsCounterView.prototype = Object.create(SCView.prototype);
    QuestionsCounterView.prototype.constructor = QuestionsCounterView;

    QuestionsCounterView.prototype.getEvents = function () {
      return {
          "click #questions-counter-container": "openQA"
      }
    }

    QuestionsCounterView.prototype.openQA = function() {
  
      //Open Q&A Section
      var mainEl = '.product-details-information-content';
      var tabEl = 'a:contains('+ this.tabName +')';
      var btnEl = 'button:contains('+ this.tabName +')';
      
      if (Utils.isPhoneDevice()) {
        jQuery(btnEl).click();
      }
      else {
        Utils.animatedScroll(mainEl);
        jQuery(tabEl).click();
      }
      
    }
    
    QuestionsCounterView.prototype.getContext = function () {

      var self = this;

      return {
        //@property {String} questionsCount
        counterText: self.counterText ? self.counterText : 'Q&A',
        questionsCount: self.questionsCount
      };
    }
    
    return QuestionsCounterView
})
